import { call, put, takeEvery } from "redux-saga/effects";
import { message } from "antd";
import { types } from "../action-types";
import { alertNotification } from "../../components/TopNotification/alertNotification";
import {
  getAllTeamMembersApi,
  addTeamMembersApi,
  updateTeamMembersApi,
  changeTeamMemberPasswordApi,
  deleteTeamMemberApi,
} from "../../API/API";

function* getAllTeamMembersSaga(params) {
  try {
    const response = yield call(() => getAllTeamMembersApi(params));
    yield put({
      type: types.GET_ALL_TEAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_ALL_TEAM_FAILURE, error });
  }
}

export function* watchGetAllTeamMembersSaga() {
  yield takeEvery(types.GET_ALL_TEAM_REQUESTED, getAllTeamMembersSaga);
}

function* addTeamMembersSaga(params) {
  try {
    const response = yield call(() => addTeamMembersApi(params.params));

    yield put({
      type: types.ADD_TEAM_SUCCESS,
      payload: response.data,
    });

  } catch (error) {
    const errorMessage = error?.response?.data?.message || "Something went wrong!";

    if (errorMessage !== "Sorry this user already exists") {
      alertNotification("error", errorMessage);
    }

    yield put({
      type: types.ADD_TEAM_FAILURE,
      payload: error?.response?.data,
    });
  }
}

export function* watchAddTeamMembersSaga() {
  yield takeEvery(types.ADD_TEAM_REQUESTED, addTeamMembersSaga);
}

function* updateTeamMembersSaga(action) {
  try {
    const api = action.options?.changePassword
      ? changeTeamMemberPasswordApi
      : updateTeamMembersApi;
    const response = yield call(api, action.inv_id, action.params);
    yield put({
      type: types.UPDATE_TEAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    message.error(error?.response?.data?.message || "Something went wrong!");
    yield put({ type: types.UPDATE_TEAM_FAILURE, error });
  }
}

export function* watchUpdateTeamMembersSaga() {
  yield takeEvery(types.UPDATE_TEAM_REQUESTED, updateTeamMembersSaga);
}

function* deleteTeamMemberSaga(action) {
  try {
    const response = yield call(() => deleteTeamMemberApi(action.memberId));
    yield put({
      type: types.DELETE_TEAM_SUCCESS,
      payload: response.data,
    });
    alertNotification("success", "Team member deleted successfully");
  } catch (error) {
    alertNotification(
      "error",
      error?.response?.data?.message || "Something went wrong!"
    );

    yield put({
      type: types.DELETE_TEAM_FAILURE,
      payload: error?.response?.data,
    });
  }
}

export function* watchDeleteTeamMemberSaga() {
  yield takeEvery(types.DELETE_TEAM_REQUESTED, deleteTeamMemberSaga);
}
